// extracted by mini-css-extract-plugin
export var errorsContainer = "_s7-1";
export var link = "_s7-0";